import type { AuftragsStatus } from '@awf/shared';
import type { Phase, PhasenZustand } from '../runs/phasen.js';
import { klasse } from './klasse.js';
import { LinienSymbol, type LinienSymbolName } from './linien-symbol.js';
import stile from './phasenleiste.module.css';
import seite from './seite.module.css';

const ZUSTAND_TEXT: Record<PhasenZustand, string> = {
  erledigt: 'erledigt',
  aktiv: 'aktiv',
  offen: 'offen',
  gescheitert: 'gescheitert',
};

/**
 * Ein Themen-Symbol statt eines Namens unter jeder Station, wie der Beitrags-Stepper der
 * Content-Factory (auftrag-detail/beitrag-stepper.tsx). Der Name bleibt vollstaendig da: im Satz
 * ueber der Schiene, als Tooltip an der Station und als Vorlesetext.
 */
export const SCHRITT_SYMBOL: Partial<Record<AuftragsStatus, LinienSymbolName>> = {
  angelegt: 'plus',
  recherche: 'search',
  entwurf: 'pencil',
  wartet_auf_freigabe: 'shield',
  wartet_auf_entscheidung: 'eye',
  finalisierung: 'target',
  fertig: 'download',
};

/**
 * Zustand aus Form UND Text, nie Farbe allein: Haken, Kern im Ring, leerer Ring, Kreuz -- und
 * fuer Hilfstechnik ein Satz je Schritt. `bewegt` nur, solange wirklich etwas laeuft.
 */
export function Phasenleiste({
  phasen,
  wartet = false,
  bewegt = false,
  kompakt = false,
}: {
  phasen: readonly Phase[];
  wartet?: boolean;
  bewegt?: boolean;
  kompakt?: boolean;
}) {
  return (
    <ol
      // Safari/VoiceOver verwirft bei list-style:none die Listensemantik, sofern sie nicht
      // ausdruecklich gesetzt ist.
      role="list"
      className={klasse(stile.leiste, kompakt && stile.kompakt)}
      aria-label="Fortschritt"
      data-bewegt={bewegt ? 'true' : undefined}
    >
      {phasen.map((phase, i) => (
        <li
          key={phase.schritt.status}
          className={stile.phase}
          data-zustand={phase.zustand}
          data-wartet={wartet && phase.zustand === 'aktiv' ? 'true' : undefined}
          aria-current={phase.zustand === 'aktiv' ? 'step' : undefined}
          title={`${phase.schritt.titel}${phase.ueberarbeitung ? ' (Überarbeitung)' : ''}`}
        >
          <span className={stile.kreis} aria-hidden="true" />
          <span className={stile.symbol} aria-hidden="true">
            <LinienSymbol name={SCHRITT_SYMBOL[phase.schritt.status] ?? 'list'} groesse={14} />
          </span>
          <span className={seite.nurVorlesen}>
            {`Schritt ${i + 1} von ${phasen.length}: ${phase.schritt.titel}${phase.ueberarbeitung ? ' (Überarbeitung)' : ''}, ${phase.abgebrochen ? 'abgebrochen' : ZUSTAND_TEXT[phase.zustand]}`}
          </span>
        </li>
      ))}
    </ol>
  );
}
